document.addEventListener('DOMContentLoaded', () => {

  const timelines = document.querySelectorAll('.timeline');

  if (!timelines.length) return;

  timelines.forEach((timeline) => {

    const items = timeline.querySelectorAll('.timeline-item');
    const progress = timeline.querySelector('.timeline-progress');
    const line = timeline.querySelector('.timeline-line');

    if (!items.length || !line || !progress) return;

    function updateLinePosition() {
      const timelineRect = timeline.getBoundingClientRect();

      const first = items[0].getBoundingClientRect();
      const last = items[items.length - 1].getBoundingClientRect();

      const firstCenter = first.top + first.height / 3;
      const lastCenter = last.top + last.height / 3;

      const top = firstCenter - timelineRect.top;
      const bottom = timelineRect.bottom - lastCenter;

      line.style.top = `${top}px`;
      line.style.bottom = `${bottom}px`;

      progress.style.top = `${top}px`;
    }

    function update() {
      const screenCenter = window.innerHeight / 3;

      let closest = null;
      let closestOffset = Infinity;

      items.forEach((item) => {
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.top + rect.height / 3;

        const offset = Math.abs(itemCenter - screenCenter);

        if (offset < closestOffset) {
          closestOffset = offset;
          closest = item;
        }
      });

      if (!closest) return;

      // ✅ ACTIVE + COMPLETED
      const itemsArray = Array.from(items);
      const activeIndex = itemsArray.indexOf(closest);

      items.forEach((item, index) => {
        item.classList.remove('active', 'completed');

        if (index === activeIndex) {
          item.classList.add('active');
        }

        if (index <= activeIndex) {
          item.classList.add('completed');
        }
      });

      // ✅ PROGRESS
      const itemRect = closest.getBoundingClientRect();
      const itemCenter = itemRect.top + itemRect.height / 3;

      const firstItem = items[0].getBoundingClientRect();
      const start = firstItem.top + firstItem.height / 3;

      const timelineRect = timeline.getBoundingClientRect();
      const total = timelineRect.height;

      const distance = itemCenter - start;

      let progressPercent = distance / total;
      progressPercent = Math.max(0, Math.min(1, progressPercent));

      progress.style.height = `${progressPercent * 100}%`;
    }

    // EVENTS (scoped but still global triggers)
    window.addEventListener('scroll', update);
    window.addEventListener('resize', () => {
      updateLinePosition();
      update();
    });

    updateLinePosition();
    update();

  });

});